import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as globals from '@reusable/services/globals';

@Injectable()
export class ContentService {
  responseData: any;
  constructor(private router: Router, private httpClient: HttpClient, private gtn: globals.GetTokenNow) {
    this.httpClient = httpClient;
  }
  getManufactures(sort, records, pageNumber, queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/core/manufactures/list/sortBy-${sort}/${records}/${pageNumber}/`, headers)
      .pipe(map(res => res as any));
  }
  getModels(manufactureId) {
    return this.httpClient
      .get(`${globals.domain}/core/models/list/sortBy-order/250/1/?manufactureId=${manufactureId}&isDeleted=false`, globals.cfAccessOptions())
      .pipe(map(res => res as any));
  }

  coreLookup(keyword) {
    return this.httpClient.get(`${globals.domain}/core/parts/lookup/?keyword=${keyword}`, globals.cfAccessOptions())
      .pipe(map((res:any) => {
        const response: any = res;
        if (response.case === 1 && response.parts?.length) {
          return response.parts;
        } else {
          return [];
        }
      }));
  }

  getSEO(manufactureName) {
    return this.httpClient.get(`${globals.domain}/core/seo/${manufactureName}/view`, globals.cfAccessOptions()).pipe(map(res => res as any));
  }

  getAreas() {
    let areas;
    return this.httpClient.get(`${globals.domain}/core/areas/list/sortBy-order/100/1/?isDeleted=false`, globals.cfAccessOptions())
      .pipe(map((res:any) => {
        areas = res;
        for (let i = 0; i < areas.areas.length; i++) {
          areas.areas[i].id = areas.areas[i]._id;
          areas.areas[i].text = areas.areas[i].nameArabic;
        }
        return areas.areas;
      }));
  }

  getCities(parentAreaId?: string, cityName?: string) {
    let cities;
    return this.httpClient
      .get(
        `${globals.domain}/core/cities/list/sortBy-nameArabic/300/1/?${parentAreaId ? `areaId=${parentAreaId}&` : ''}${cityName ? `$text[$search]=${cityName}&` : ''
        }isDeleted=false`
      )
      .pipe(map((res:any) => {
        cities = res;
        return cities;
      }));
  }

  listCitiesWithAreas(sort, records, pageNumber, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/core/cities/list-with-areas/sortBy-${sort}/${records}/${pageNumber}/`, updateQueries)
      .pipe(map(res => res as any));
  }


  getFAQ() {
    return this.httpClient.get(`${globals.domain}/core/faq/list/sortBy--nameEnglish/null/1/`, globals.cfAccessOptions()).pipe(map(res => res as any));
  }

  sendMessage(body) {
    return this.httpClient.post(`${globals.domain}/core/misc/contact-us/`, body).pipe(map(res => res as any));
  }

  workshopApplication(body) {
    return this.httpClient.post(`${globals.domain}/core/misc/workshop-application/`, body).pipe(map(res => res as any));
  }
  createWorkshopApplication(body) {
    return this.httpClient.post(`${globals.domain}/business/register/`, body).pipe(map(res => res as any));
  }

  getSingleModels(modelName) {
    return this.httpClient.get(`${globals.domain}/core/models/list/sortBy-order/1/1/?nameArabic=${modelName}`, globals.cfAccessOptions()).pipe(map(res => res as any));
  }
  getSingleManufacture(manufactureId) {
    return this.httpClient.get(`${globals.domain}/core/manufactures/${manufactureId}/view`, globals.cfAccessOptions()).pipe(map(res => res as any));
  }
  getBankList() {
    return this.httpClient.get(`${globals.domain}/core/bank-accounts/list/sortBy--nameEnglish/null/1/`, globals.cfAccessOptions()).pipe(map(res => res as any));
  }

  listCarClasses(sort, records, pageNumber, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/core/car-class/list/sortBy-${sort}/${records}/${pageNumber}/`, updateQueries)
      .pipe(map(res => res as any));
  }
  // viewW3W(lng, lat) {
  //   return this.httpClient.get(globals.domain + '/core/w3w/view/?lng=' + lng + '&lat=' + lat, this.gtn.getHeaders()).map(res => {
  //     return res as any;
  //   });
  // }
  // gridW3W(swlat, swlng, nelat, nelng) {
  //   return this.httpClient
  //     .get(
  //       globals.domain + '/core/w3w/grid/?swlat=' + swlat + '&swlng=' + swlng + '&nelat=' + nelat + '&nelng=' + nelng,
  //       this.gtn.getHeaders()
  //     )
  //     .map(res => {
  //       return res as any;
  //     });
  // }
  listParts(queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient.get(`${globals.domain}/elastic-search/list/`, updateQueries).pipe(map(res => res as any));
  }
}